import _ from 'lodash';
import React from 'react';
import {withTranslation} from 'react-i18next';

import {unwrapNullableDataType} from '../../../ducks/formattersettingshelpers';
import {useFormatterById} from '../../FormattersContext';
import {EditorDetail} from './EditorDetail';

function ArrayFormatter({formatter, entity, fieldName, entityType, setFormField, t}) {
    const arrayDataType = unwrapNullableDataType(entityType);
    const subFormatter = useFormatterById(formatter.settings.entryFormatterId);
    let FieldFormatter = subFormatter;

    if (!entity) return null;

    if (_.isEmpty(entity)) return <i>{t('generalShared.none')}</i>;

    return (
        <div>
            {entity.map((child, ix) => (
                <EditorDetail key={ix}>
                    <FieldFormatter.Formatter
                        entityType={arrayDataType.childDataType}
                        formatter={subFormatter}
                        entity={child}
                        fieldName={fieldName + '[' + ix + ']'}
                        setFormField={setFormField}
                    />
                </EditorDetail>
            ))}
        </div>
    );
}

export default withTranslation()(ArrayFormatter);
